"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getJSON;

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

function isResponseJSON(response) {
  var contentType = response.headers.get('Content-Type');
  return contentType && contentType.indexOf('json') >= 0;
}

function isResponseEmpty(response) {
  var emptyCodes = [204, 205];
  return emptyCodes.indexOf(response.status) >= 0;
}
/**
 * Extract JSON body from a server response
 */


function getJSON(response) {
  return !isResponseEmpty(response) && isResponseJSON(response) ? response.json() : _promise.default.resolve();
}